import { schema } from "normalizr";

const OEMReports = new schema.Entity("OEMReports");
const OEMReport = new schema.Entity("OEMReport");

export default {
    OEM_REPORTS: { data: [OEMReports] },
    OEM_REPORT: { OEMReport }
};
